<template>
  <div class="flex flex-col w-full items-center relative gap-48 lg:gap-32">
    <div v-for="(item, i) in arcData" :key="item.id" class="w-full contents">
      <div :class="[item.id == 1 ? 'top-[14.5%] lg:top-[17%]':'', item.id > 0 ? 'shadow-card' : 'shadow-lg']" class="h-auto lg:h-[80vh] 2xl:h-[72vh] w-full bg-ip-color-12 rounded-3xl overflow-clip flex flex-col sticky top-[9%] lg:top-[12%]">
        <div class="lg:hidden aspect-[360/200] overflow-hidden relative">
          <div class="absolute top-6 left-6 xl:top-[2%] xl:left-[2%] z-3">
            <div class="absolute top-0 w-fit bg-ip-color-10 text-ip-color-3 uppercase figtree font-bold text-[20px] leading-normal md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] py-1 px-2 rounded-md">{{ item.name }}</div>
          </div>
          <div class="absolute w-full h-full top-0 left-0 figure-arc-overlay z-1"></div>
          <figure class="w-full h-full">
            <img :src="item.img" alt="" class="w-full h-full object-cover object-[0px_-15px]" loading="lazy" format="webp" quality="80">
          </figure>
        </div>
        <div class="flex-grow flex flex-row items-stretch">
          <div class="lg:w-[55%] relative p-4 md:p-6 lg:p-[2.5vw] h-full">
            <div class="w-full h-full flex flex-col justify-between relative z-1">
              <div class="text-white relative">
                <div class="space-y-5 lg:space-y-7">
                  <div class="flex lg:flex-col items-center lg:items-start gap-4">
                    <div class="w-10 h-10 md:w-12 md:h-12 lg:w-18 lg:h-18 xl:w-[5vw] xl:h-[5vw] ">
                      <VectorAct v-if="item.name == 'act'"/>
                      <VectorReport v-if="item.name == 'report'"/>
                      <VectorComs v-if="item.name == 'communicate'"/>
                    </div>
                    <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree">Scope of Work</div>
                  </div>
                  <div class="space-y-4 lg:space-y-6">
                    <div class="space-y-2 lg:space-y-3">
                      <div class="text-ip-color-10 text-[16px] leading-[20px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.2vw] lg:leading-[1.8vw] font-bold figtree" v-html="item.point[0].title"></div>
                      <div class="text-[14px] leading-[22px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.5vw] figtree md:tracking-[0.5px] lg:tracking-[.1vh]" v-html="item.point[0].desc"></div>
                    </div>
                    <div class="space-y-2 lg:space-y-3">
                      <div class="text-ip-color-10 text-[16px] leading-[20px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.2vw] lg:leading-[1.8vw] font-bold figtree" v-html="item.point[1].title"></div>
                      <div class="text-[14px] leading-[22px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.5vw] figtree md:tracking-[0.5px] lg:tracking-[.1vh]" v-html="item.point[1].desc"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="absolute w-72 h-72 opacity-5 bottom-0 left-0">
              <VectorSingleArrow color="ip-color-10" class="w-full h-full"/>
            </div>
          </div>
          <div class="hidden lg:block lg:w-[45%] relative bg-ip-color-12 p-10">
            <figure class="absolute top-0 left-0 w-full h-full">
              <img :src="item.img" alt="" class="w-full h-full object-cover" loading="lazy" format="webp" quality="80">
            </figure>
            <div class="absolute w-full h-full top-0 left-0 figure-arc-overlay z-1"></div>
            <div class="flex flex-col justify-between h-full relative z-2">
              <div class="relative">
                <div class="absolute top-0 w-fit bg-ip-color-10 text-ip-color-3 uppercase figtree font-bold text-[24px] leading-[48px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] p-2 rounded-md">{{ item.name }}</div>
              </div>
              <div class=""></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const arcData = ref([
  {
    id: 0,
    name: 'act',
    img: '/images/arc/arc-1.webp',
    point: [
      {
        title: 'Capacity Building',
        desc: 'We empower you by boosting your skills, knowledge, and capabilities, setting <br class="hidden md:inline">the stage for sustainable growth and effective responses to your <br class="hidden md:inline">sustainability challenges.',
      },

      {
        title: 'Sustainability Initiatives & <br class="md:hidden">Partnership Building',
        desc: 'We help you design and execute impactful sustainability initiatives and <br class="hidden md:inline">establish strategic partnerships that amplify positive environmental and <br class="hidden md:inline">social impacts.',
      },
    ],
  },
  {
    id: 1,
    name: 'report',
    img: '/images/arc/arc-2.webp',
    point: [
      {
        title: 'Sustainability Report Writing & Consultation:',
        desc: 'Preparing and writing sustainability reports <br class="md:hidden">that meet the Global Reporting <br class=" md:inline">Initiative (GRI) standards.',
      },

      {
        title: 'Creative Development:',
        desc: 'Providing guidance and crafting engaging content like stories, visuals, and <br class="hidden md:inline">videos to showcase your sustainability journey. By leveraging AI and apps, <br class="hidden md:inline">we make your data creatively accessible and understandable to all.',
      },
    ],
  },
  {
    id: 2,
    name: 'communicate',
    img: '/images/arc/arc-3.webp',
    point: [
      {
        title: 'Strategic Blueprinting',
        desc: 'Dive deep into stakeholder analysis and mapping to craft tailored ESG <br class="hidden md:inline">strategies. We meticulously plot your sustainability journey, focusing on <br class="hidden md:inline">impactful engagement methods that resonate with every stakeholder <br class="hidden md:inline">segment, ensuring your vision is not just seen but felt.',
      },

      {
        title: 'Stakeholder Engagement',
        desc: 'Turning strategy into action, we implement your ESG initiatives with <br class="hidden md:inline">precision. From deploying targeted engagement tactics to leveraging the <br class="hidden md:inline">latest communication tools, we ensure your sustainability efforts create <br class="hidden md:inline">lasting impressions and tangible outcomes.',
      },
    ],
  },
]);
</script>

<style lang="scss" scoped>
.figure-arc-overlay{
  background: rgb(38,38,104);
  background: linear-gradient(180deg, rgba(38,38,104,0) 0%, rgba(38,38,104,0) 20%, rgba(38,38,104,1) 100%);
}
.shadow-card {
  // box-shadow: rgba(0, 0, 0, 0.2) 0px 7px 29px 0px;

  box-shadow: -1px -16px 23px -7px rgba(0,0,0,0.40);
  -webkit-box-shadow: -1px -16px 23px -7px rgba(0,0,0,0.40);
  -moz-box-shadow: -1px -16px 23px -7px rgba(0,0,0,0.40);
}
</style>
